import { render, staticRenderFns } from "./FitmentHistoryView.vue?vue&type=template&id=5a4736bb&scoped=true&"
import script from "./FitmentHistoryView.vue?vue&type=script&lang=js&"
export * from "./FitmentHistoryView.vue?vue&type=script&lang=js&"
import style0 from "./FitmentHistoryView.vue?vue&type=style&index=0&id=5a4736bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4736bb",
  null
  
)

export default component.exports